import type { TFunction } from 'i18next'

const statusVariant: Record<string, 'danger' | 'info' | 'neutral' | 'success' | 'warning'> = {
  active: 'success',
  banned: 'warning',
  draft: 'neutral',
  pending_publish: 'info',
  testing: 'info',
} as const

export function getStatusVariant(status: string) {
  return statusVariant[status] ?? 'neutral'
}

export function formatAppType(appType: string, labels: Map<string, string>) {
  return labels.get(appType) ?? appType.replaceAll('_', ' ')
}

export function formatDateTime(value: string) {
  const date = new Date(value)

  if (Number.isNaN(date.getTime())) {
    return value.length > 0 ? value : '-'
  }

  return new Intl.DateTimeFormat('zh-CN', {
    day: '2-digit',
    hour: '2-digit',
    hour12: false,
    minute: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
    .format(date)
    .replaceAll('/', '-')
}

export function translateStatus(t: TFunction<'adminApps'>, status: string) {
  const key = `status.${status}`
  const translated = t(key)

  return translated === key ? status : translated
}
